const TEXT_SEPARATOR = " - ";

function cleanText(value) {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  return text && text.toLowerCase() !== "undefined" && text.toLowerCase() !== "null"
    ? text
    : "";
}

function getFirstText(vehicle, fields) {
  for (const field of fields) {
    const value = cleanText(vehicle?.[field]);
    if (value) return value;
  }
  return "";
}

export function getVehicleIdentifier(vehicle) {
  const plate = getFirstText(vehicle, ["plateNo", "plateNumber", "licensePlate"]);
  if (plate) return { label: "Plate", value: plate, text: `Plate ${plate}` };

  const unit = getFirstText(vehicle, ["unitCode", "code", "internalCode", "vehicleCode"]);
  if (unit) return { label: "Unit", value: unit, text: `Unit ${unit}` };

  const id = cleanText(vehicle?._id || vehicle?.id);
  if (id) {
    const suffix = id.slice(-6).toUpperCase();
    return { label: "ID", value: suffix, text: `ID ${suffix}` };
  }

  return { label: "", value: "", text: "" };
}

export function getVehicleIdentifierText(vehicle) {
  return getVehicleIdentifier(vehicle).text;
}

export function getVehicleName(vehicle, fallback = "Vehicle") {
  const explicitName = getFirstText(vehicle, ["name", "vehicleName", "title"]);
  const parts = [
    getFirstText(vehicle, ["make", "brand"]),
    getFirstText(vehicle, ["model"]),
    getFirstText(vehicle, ["year"]),
  ].filter(Boolean);
  return explicitName || parts.join(" ") || fallback;
}

export function getVehicleSeatCount(vehicle) {
  const value = [vehicle?.seater, vehicle?.seats, vehicle?.capacity, vehicle?.passengerCapacity, vehicle?.maxPassengers]
    .map((item) => Number(item))
    .find((item) => Number.isFinite(item) && item > 0);
  return value || 0;
}

export function getVehicleTransmission(vehicle) {
  const value = getFirstText(vehicle, ["transmission", "transmissionType", "gearbox"]);
  if (!value) return "";
  if (/auto/i.test(value)) return "Automatic";
  if (/manual/i.test(value)) return "Manual";
  return value;
}

export function getVehicleColor(vehicle) {
  return getFirstText(vehicle, ["color", "vehicleColor"]);
}

export function getVehicleCategory(vehicle) {
  return getFirstText(vehicle, ["category", "type"]);
}

export function getVehicleFuel(vehicle) {
  return getFirstText(vehicle, ["fuelType", "fuel", "engineType"]);
}

export function getVehicleLocation(vehicle) {
  return getFirstText(vehicle, ["location", "branch"]);
}

export function getVehicleDetailLine(vehicle) {
  const seats = getVehicleSeatCount(vehicle);
  return [
    getVehicleColor(vehicle),
    getVehicleCategory(vehicle),
    getVehicleTransmission(vehicle),
    seats ? `${seats} seats` : "",
    getVehicleFuel(vehicle),
    getVehicleLocation(vehicle),
  ]
    .filter(Boolean)
    .join(TEXT_SEPARATOR);
}

export function getVehicleOptionLabel(vehicle) {
  if (!vehicle) return "";
  return [
    getVehicleName(vehicle),
    getVehicleIdentifierText(vehicle),
    getVehicleColor(vehicle),
    getVehicleTransmission(vehicle),
    getVehicleSeatCount(vehicle) ? `${getVehicleSeatCount(vehicle)} seats` : "",
  ]
    .filter(Boolean)
    .join(TEXT_SEPARATOR);
}

export function getCompactVehicleLabel(vehicle) {
  if (!vehicle) return "";
  const identifier = getVehicleIdentifier(vehicle);
  return [getVehicleName(vehicle), identifier.value].filter(Boolean).join(TEXT_SEPARATOR);
}
